import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Send, Loader2, Users } from "lucide-react";

export function SendMaterialButton({ club, week, onSent }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!window.confirm("Enviar já a apresentação e o QR ao Secretário e ao Capitão desta sessão?")) return;
    setBusy(true);
    try {
      const r = await api.post("/weekly-sessions/send-material", { club, week });
      toast.success(`Enviado a ${r.data.sent} pessoa(s)${r.data.captain ? "" : " — ainda sem Capitão escolhido"}`);
      onSent?.();
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <button onClick={send} disabled={busy} data-testid={`session-send-material-${club}`}
      className="kw-btn-primary !py-1 !px-2 text-[10px] inline-flex items-center gap-1">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Send className="w-3 h-3" />} Enviar agora
    </button>
  );
}

export function SendNextMaterialButton({ club, week, title, onSent }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!window.confirm(`Enviar o PDF, o áudio e o PowerPoint de «${title || `semana ${week}`}» a TODOS os coopetidores dos ${club}?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/weekly-sessions/send-next-material", { club, week });
      toast.success(`Material enviado a ${r.data.sent} de ${r.data.total} coopetidores`);
      onSent?.();
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <button onClick={send} disabled={busy} data-testid={`session-send-next-${club}`}
      className="kw-btn-secondary !py-1 !px-2 text-[10px] inline-flex items-center gap-1">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Users className="w-3 h-3" />} Material a todos
    </button>
  );
}
